<template>
  <div class="page">
    <navigation
      class="header"
      :theme="{
        background: '#fff',
      }"
    >账号注销
    </navigation>
    <div class="content">
      <div class="separator"></div>
      <div class="notice">
        <div class="title font-large text-dark">验证手机号</div>
        <div class="font-28 text-dark">您当前正在进行注销操作
        </div>
        <div class="font-28 text-dark">为确认您为本人操作，需验证手机号</div>
        <div class="font-28 text-gray">
          验证码已发送至您的手机 {{userInfo.mobile | mobile}}
        </div>
      </div>
      <form class="input" ref="form" onsubmit="return false;">
        <div class="form-item underline-un-focus code">
          <nd-input
            v-model="form.smsCode"
            name="smsCode"
            type="pure-number"
            maxLength="6"
            placeholder="请输入验证码"
            @blur="codeBlur"
          >
          </nd-input>
        </div>
        <p class="error-tip error" v-if="errorTip">{{ errorTip }}</p>
        <nd-send-code
          fmt="已发送(ms)"
          ref="smsCode"
          class="send-code"
          :sendCode="sendCodeHandler"
          v-if="showSendCode"
        />
      </form>
      <nd-button :disabled="isDisabled" @click="confirmSignout">确认注销</nd-button>
    </div>
  </div>
</template>

<script>
import { getKey } from '@/assets/utils'
import validate from '../../../components/nd-validate'
import { mapActions } from 'vuex'

export default {
  created () {
    this.userInfo = getKey('userInfo')
    this.form.mobile = this.userInfo.mobile
    this.$bus.$emit('ready')
  },
  mixins: [validate],
  computed: {
    showSendCode () {
      return this.validateWithoutTip({ mobile: this.form.mobile })
    }
  },
  data () {
    return {
      userInfo: {},
      form: {
        mobile: '',
        smsCode: '',
        smsKey: ''
      },
      rules: {
        smsCode: [
          {
            require: true,
            message: '请输入验证码',
            trigger: 'blur'
          },
          {
            regular: /[0-9]{6}$/,
            message: '验证码错误，请重新输入',
            trigger: 'blur'
          }
        ]
      },
      isDisabled: true,
      errorTip: ''
    }
  },
  methods: {
    ...mapActions('user', ['getCommonSmsCode', 'cancelConfirm']),
    async sendCodeHandler () {
      return new Promise((resolve, reject) => {
        this.getCommonSmsCode({
          smsType: 'USER_INFO_CANCEL'
        })
          .then((result) => {
            if (result.success) {
              this.form.smsKey = result.data.smsKey
              resolve(true)
            } else {
              reject(new Error(result.msg))
            }
          })
      })
    },
    async confirmSignout () {
      const { success, data, msg } = await this.cancelConfirm({
        smsKey: this.form.smsKey,
        smsCode: this.form.smsCode
      })
      if (success) {
        if (data.result === 'Y') {
          this.$router.push({
            path: '/mine/signout/result',
            query: {
              signedOut: 'Y'
            }
          })
        } else {
          this.errorTip = msg
        }
      }
    },
    codeBlur () {
      if (this.form.smsCode) {
        this.validateWithoutTip(this.rules)
      }
    }
  }
}
</script>

<style lang="less" scoped>
@import "../../../assets/less/mixin.less";

.page {
  width: 750px;
  height: 100%;
  background: #fff;
  .content {
    .separator {
      width: 100%;
      height: 20px;
      background: #fafafa;
    }
    .notice {
      padding: 50px 40px;
      .title {
        margin-bottom: 20px;
      }
    }
    .input {
      // padding: 30px 40px;
      padding: 0 50px;
      margin-top: 30px;
      position: relative;
      .form-item {
        &.code {
          .nd-input {
            margin-right: 160px;
            width: unset;
          }
        }

        .nd-input {
          height: 42px;
          line-height: 42px;
          margin-bottom: 8px;
        }
      }
      .send-code {
        width: 150px;
        border-radius: 28px;
        bottom: 8px;
        right: 50px;
        position: absolute;

        span {
          display: inline-block;
          font-size: 22px;
        }
      }

      .error-tip {
        font-size: 24px;
        height: 33px;
        line-height: 33px;
        bottom: -50px;
        position: absolute;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
      }
    }
  }
  .nd-button {
    margin: 123px auto;
  }
  .font-large {
    font-size: 42px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    line-height: 59px;
  }
  .font-28 {
    font-size: 28px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    line-height: 48px;
  }
  .font-32 {
    font-size: 32px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    line-height: 45px;
  }
  .text-dark {
    color: #333;
  }
  .text-gray {
    color: #999;
  }
  .text-placeholder {
    color: #ccc;
  }
}
</style>